module.exports = __webpack_public_path__ + "static/media/bitva2.70a69c59.mp3";